module.exports = __webpack_public_path__ + "static/media/icon-lp-online-assessment.e1c24061.svg";